/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './SettingTabletView.scss'
import React, { Component } from 'react'
import { DragSource, DropTarget } from 'react-dnd'
import { findDOMNode } from 'react-dom'
import r from '../../../util/Renderer'
import history from '../../../util/history'
import { DeleteButton, DeleteIcon, FileInput, Icon, ListItem, NavigationTabs, TextInput, Title } from '../../atoms'
import { ListGroup } from '../../molecules'
import SettingTab from '../../organisms/room/SettingTab'
import Cell from '../../templates/Cell'
import TabletsAction from '../../../action/tablet'
import HouseManualAction from '../../../action/hotel_manual'
import RoomAction from '../../../action/room'
import { NormalButton, NavigationDrawer, OutlinedButton } from 'ui-library/dist/external/components'

function SettingTabletView(props) {
  // ハウスマニュアル編集ダイアログ時に設定される
  const manualId = Object.prototype.hasOwnProperty.call(props.match.params, 'mid') ? props.match.params.mid : null
  const room = props.room
  const edited = props.settingTablet.edited
  const tabs = SettingTab.getTabMenus(room.id)
  const toolbar = { label: `宿の設定 [${room.name}]`, items: props.accountMenu }

  return (
    <div id="SettingTablet">
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} />
      <div className="SettingTablet__NavigationTabs">
        <NavigationTabs className="SettingTablet__NavigationTabs" tabs={tabs}>
          <h3 className="title">タブレット</h3>
          <div className="row">
            <div className="col-12">
              <p>TOMARUBA Home を使う場合は設定してください</p>
              {/*
                <ul className="NavigationLinks">
                  <li><a href="#basic">基本設定</a></li>
                  <li><a href="#manual">ハウスマニュアル</a></li>
                  <li><a href="#terminal">利用端末</a></li>
                </ul>
              */}
            </div>
          </div>

          <div className="title">
            <a name="basic">基本設定</a>
            <div className="previewButton" onClick={() => history.push('/setting/' + room.id + '/tablet/preview')} />
          </div>
          <TabletPreviewDialog roomId={room.id}>{props}</TabletPreviewDialog>

          <div className="row">
            <div className="col-12">
              <ListGroup className="BasicGroup" border="surround">
                <ListItem>
                  <div className="row">
                    <div className="col-12 col-sm-6 col-md-6 col-lg-5 align-self-center">
                      <Cell className="basicForm">
                        <div className="basicLabel">
                          ホーム画面のロゴ
                          {r.renderIf(room.logo_url)(<Icon className="icon" type="preview" onClick={e => window.open(`${room.logo_url}`, '_blank')} />)}
                        </div>
                        <p className="basicNote">（横:630px, 縦:896px）</p>
                      </Cell>
                    </div>
                    <div className="col-auto col-md-auto align-self-center">
                      <Cell className="Cell__FileUpload">
                        <Icon className="ImgIcon" type="img" />
                        <FileInput
                          label={room.logo_name}
                          isDialog={true}
                          className="FileUpload"
                          name="logo_url"
                          onChange={e => RoomAction.onUpload(room, e)}
                          onClear={e => RoomAction.onClear('logo', room)}
                        />
                      </Cell>
                    </div>
                  </div>
                </ListItem>
                <ListItem>
                  <div className="row">
                    <div className="col-12 col-sm-6 col-md-6 col-lg-5 align-self-center">
                      <Cell className="basicForm">
                        <div className="basicLabel">
                          言語選択時のロゴ
                          {r.renderIf(room.top_logo_url)(<Icon className="icon" type="preview" onClick={e => window.open(`${room.top_logo_url}`, '_blank')} />)}
                        </div>
                        <p className="basicNote">（横:508px, 縦:724px）</p>
                      </Cell>
                    </div>
                    <div className="col-auto col-md-auto align-self-center">
                      <Cell className="Cell__FileUpload">
                        <Icon className="ImgIcon" type="img" />
                        <FileInput
                          label={room.top_logo_name}
                          isDialog={true}
                          className="FileUpload"
                          name="top_logo_url"
                          onChange={e => RoomAction.onUpload(room, e)}
                          onClear={e => RoomAction.onClear('top_logo', room)}
                        />
                      </Cell>
                    </div>
                  </div>
                </ListItem>
                <ListItem>
                  <div className="row">
                    <div className="col-12 col-sm-6 col-md-6 col-lg-5 align-self-center">
                      <Cell className="basicForm">
                        <div className="basicLabel">
                          ホーム画面の画像
                          {r.renderIf(room.image_url)(<Icon className="icon" type="preview" onClick={e => window.open(`${room.image_url}`, '_blank')} />)}
                        </div>
                        <p className="basicNote">（横:1536px, 縦:1370px）</p>
                      </Cell>
                    </div>
                    <div className="col-auto col-md-auto align-self-center">
                      <Cell className="Cell__FileUpload">
                        <Icon className="ImgIcon" type="img" />
                        <FileInput
                          label={room.image_name}
                          isDialog={true}
                          className="FileUpload"
                          name="image_url"
                          onChange={e => RoomAction.onUpload(room, e)}
                          onClear={e => RoomAction.onClear('image', room)}
                        />
                      </Cell>
                    </div>
                  </div>
                </ListItem>
                <ListItem>
                  <div className="row">
                    <div className="col-12 col-sm-6 col-md-6 col-lg-5 align-self-center">
                      <Cell className="basicForm">
                        <div className="basicLabel">
                          メニュー下部の画像
                          {r.renderIf(room.menu_image_url)(<Icon className="icon" type="preview" onClick={e => window.open(`${room.menu_image_url}`, '_blank')} />)}
                        </div>
                        <p className="basicNote">（横:1536px, 縦:770px）</p>
                      </Cell>
                    </div>
                    <div className="col-auto col-md-auto align-self-center">
                      <Cell className="Cell__FileUpload">
                        <Icon className="ImgIcon" type="img" />
                        <FileInput
                          label={room.menu_image_name}
                          isDialog={true}
                          className="FileUpload"
                          name="menu_image_url"
                          onChange={e => RoomAction.onUpload(room, e)}
                          onClear={e => RoomAction.onClear('menu_image', room)}
                        />
                      </Cell>
                    </div>
                  </div>
                </ListItem>
                <ListItem>
                  <div className="row">
                    <div className="col-12 col-sm-6 col-md-6 col-lg-5 align-self-center">
                      <Cell className="basicForm">
                        <div className="basicLabel2">
                          宿の情報
                          {r.renderIf(room.information_url)(<Icon className="icon" type="preview" onClick={e => window.open(`${room.information_url}`, '_blank')} />)}
                        </div>
                      </Cell>
                    </div>
                    <div className="col-auto col-md-auto align-self-center">
                      <Cell className="Cell__FileUpload">
                        <Icon className="ImgIcon" type="pdf" />
                        <FileInput
                          label={room.information_name}
                          isDialog={true}
                          className="FileUpload"
                          name="information_url"
                          accept="application/pdf"
                          onChange={e => RoomAction.onUpload(room, e)}
                          onClear={e => RoomAction.onClear('information', room)}
                        />
                      </Cell>
                    </div>
                  </div>
                </ListItem>
                <ListItem>
                  <div className="row">
                    <div className="col-12 col-sm-6 col-md-6 col-lg-5 align-self-center">
                      <Cell className="basicForm">
                        <p className="basicLabel2">周辺情報 (Google Map)</p>
                      </Cell>
                    </div>
                    <div className="col-auto col-md-auto align-self-center">
                      <Cell>
                        <TextInput className="mapUrl" value={room.map_url} type="text" name="map_url" placeholder={''} onChange={e => RoomAction.onEdit(room, e)} />
                      </Cell>
                      <Cell>
                        <OutlinedButton type="primary" size="lg" disabled={!edited} onClick={e => RoomAction.onRequestUpdate(room)}>
                          保存
                        </OutlinedButton>
                      </Cell>
                    </div>
                  </div>
                </ListItem>
              </ListGroup>
            </div>
          </div>

          <h3 className="title">
            <a name="manual">ハウスマニュアル</a>
          </h3>
          <div className="row">
            <div className="col-12">
              <HouseManuals roomId={room.id} name={room.name}>
                {props.manuals}
              </HouseManuals>
            </div>
          </div>
          <ManualDialog roomId={room.id} name={room.name} manualId={manualId}>
            {props}
          </ManualDialog>

          <h3 className="title">
            <a name="terminal">利用端末</a>
          </h3>
          <div className="row">
            <div className="col-md-12 col-lg-10 col-xl-8">
              <ListGroup className="TerminalGroup" border="underline">
                <Tablets roomId={room.id}>{props}</Tablets>
              </ListGroup>
            </div>
          </div>
        </NavigationTabs>
      </div>
    </div>
  )
}

function Tablets(props) {
  if (!props.children.tablets || props.children.tablets.length === 0)
    return (
      <ListItem>
        <p>登録されていません</p>
      </ListItem>
    )

  return props.children.tablets.map(t => {
    return (
      <ListItem key={t.uuid}>
        <div className="row">
          <div className="col-12 col-sm-6 col-md-6 col-lg-8 align-self-center">
            <Cell className="uuid">
              <span>{t.uuid}</span>
            </Cell>
          </div>
          <div className="col-auto col-md-auto ml-auto align-self-center">
            <Cell className="logoutCell">
              <DeleteButton className="logoutTerminal" size="md" onClick={() => TabletsAction.onRequestDelete(props.roomId, t.uuid)}>
                ログアウト
              </DeleteButton>
            </Cell>
          </div>
        </div>
      </ListItem>
    )
  })
}

function TabletPreviewDialog(props) {
  const showTabletPreviewDialog = Object.prototype.hasOwnProperty.call(props.children, 'showTabletPreviewDialog') ? props.children.showTabletPreviewDialog : false
  if (!showTabletPreviewDialog) return null

  return (
    <div id="overlay">
      <div className="TabletPreviewDialog">
        <div className="TabletPreviewDialog__image">
          <div className="TabletPreviewDialog__comments--top">ホーム画面の画像</div>
          <div className="TabletPreviewDialog__comments--topLogo">ホーム画面のロゴ</div>
          <div className="TabletPreviewDialog__comments--selectLangLogo">言語選択時のロゴ</div>
          <div className="TabletPreviewDialog__comments--menu">メニュー下部の画像</div>
          <div className="TabletPreviewDialog__imageTop" />
          <div className="TabletPreviewDialog__imageSelectLang" />
          <div className="TabletPreviewDialog__imageMenu" />
        </div>
        <NormalButton onClick={() => history.push('/setting/' + props.roomId + '/tablet')}>完了</NormalButton>
      </div>
    </div>
  )
}

// ---------------------------------------------------------------------------------------------------------------------
// ハウスマニュアルの並び替え処理（React DnD）
// ---------------------------------------------------------------------------------------------------------------------
const manualSource = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index,
      position: props.position,
      roomId: props.roomId
    }
  }
}
const manualTarget = {
  // ドラッグ中に実行される処理
  hover(props, monitor, component) {
    const srcIndex = monitor.getItem().index
    const targetIndex = props.index

    if (srcIndex === targetIndex) {
      return
    }

    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
    const clientOffset = monitor.getClientOffset()
    const hoverClientY = clientOffset.y - hoverBoundingRect.top

    if (srcIndex < targetIndex && hoverClientY < hoverMiddleY) {
      return
    }

    if (srcIndex > targetIndex && hoverClientY > hoverMiddleY) {
      return
    }

    props.dragItem(srcIndex, targetIndex)

    monitor.getItem().index = targetIndex
  },
  // ドロップしたときに実行される処理
  drop(props, monitor, component) {
    const srcIndex = monitor.getItem().index
    const srcPos = monitor.getItem().position

    if (srcIndex + 1 === srcPos) {
      return
    }

    const srcId = monitor.getItem().id
    const roomId = monitor.getItem().roomId

    HouseManualAction.onDropItem(srcId, srcIndex, roomId)
  }
}
function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }
}
function collectTarget(connect) {
  return {
    connectDropTarget: connect.dropTarget()
  }
}
// ---------------------------------------------------------------------------------------------------------------------

function HouseManuals(props) {
  const manuals = props.children
  if (!manuals || manuals.length === 0) return null

  return (
    <ListGroup className="ManualGroup" border="surround">
      {(() => {
        return manuals.map((m, i) => (
          <HouseManualItem
            key={m.id}
            index={i}
            id={m.id}
            position={m.position}
            roomId={props.roomId}
            name={props.name}
            dragItem={(srcIndex, targetIndex) => HouseManualAction.onDragItem(srcIndex, targetIndex)}
          >
            {m}
          </HouseManualItem>
        ))
      })()}
      <ListItem>
        <Cell>
          <OutlinedButton
            onClick={() =>
              history.push('/setting/' + props.roomId + '/manuals/new', {
                name: props.name
              })
            }
          >
            ＋ 追加する
          </OutlinedButton>
        </Cell>
      </ListItem>
    </ListGroup>
  )
}
function showTitle(titles) {
  return Array.from(Object.values(titles))
    .map(v => v)
    .join('・')
}

class HouseManual extends Component {
  render() {
    const manual = this.props.children
    const { connectDragSource, connectDropTarget } = this.props
    const style = { borderBottom: '1px solid rgba(0, 0, 0, 0.125)' }
    return connectDragSource(
      connectDropTarget(
        <div style={{ ...style }}>
          <ListItem>
            <div className="row">
              <div className="col-12 col-sm-6 col-md-6 col-lg-5 align-self-center">
                <Cell className="label">
                  <span>
                    {showTitle(manual.title)}
                    <Icon className="icon" type="preview" onClick={e => window.open(`${manual.manual_url}`, '_blank')} />
                  </span>
                </Cell>
              </div>
              <div className="col align-self-center">
                <Cell className="sort">
                  <button>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <g fill="none" fillRule="evenodd" stroke="#818181" strokeWidth="1.2">
                        <path d="M3 18h18M3 6h18M3 12h18" />
                      </g>
                    </svg>
                  </button>
                </Cell>
                <Cell className="more">
                  <div className="editButton">
                    <Icon
                      type="edit--black"
                      onClick={e =>
                        history.push('/setting/' + this.props.roomId + '/manuals/edit/' + manual.id, {
                          name: this.props.name
                        })
                      }
                    />
                  </div>
                  <div className="deleteButton">
                    <DeleteIcon onClick={() => HouseManualAction.onDelete(this.props.roomId, manual.id)}>削除</DeleteIcon>
                  </div>
                </Cell>
              </div>
            </div>
          </ListItem>
        </div>
      )
    )
  }
}

const HouseManualItem = DragSource('house_manual', manualSource, collectSource)(DropTarget('house_manual', manualTarget, collectTarget)(HouseManual))

function ManualDialog(props) {
  const showManualDialog = Object.prototype.hasOwnProperty.call(props.children, 'showManualDialog') ? props.children.showManualDialog : false
  if (!showManualDialog) return null

  const roomId = props.roomId
  const name = props.name
  const manualId = props.manualId
  const record = props.children.selectedManual

  const saveAction = manualId ? e => HouseManualAction.onUpdate(manualId, record, roomId, name) : e => HouseManualAction.onCreate(roomId, record, name)
  const titleOfDialog = manualId ? 'ハウスマニュアルの編集' : 'ハウスマニュアルの登録'

  return (
    <div id="overlay">
      <div className="ManualDialog">
        <Title>{titleOfDialog}</Title>
        <div className="row ManualDialog__pdf">
          <div className="col">
            <p>
              マニュアル(PDF)
              <span className="required">*</span>
            </p>
            <FileInput label={record.manual_name} name="manual" accept="application/pdf" type="pdf" onChange={e => HouseManualAction.onEdit(e)} onClear={e => HouseManualAction.onClear()} />
          </div>
        </div>
        <div className="ManualDialog__title">
          <p>
            タイトル
            <span className="required">*</span>
          </p>
          <div className="row">
            <div className="col-6">
              <LabeledInputField label="Japanese" name="title_ja" value={record.title_ja} onChange={e => HouseManualAction.onEdit(e)} />
            </div>
            <div className="col-6">
              <LabeledInputField label="English" name="title_en" value={record.title_en} onChange={e => HouseManualAction.onEdit(e)} />
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <LabeledInputField label="Chinese" name="title_zh" value={record.title_zh} onChange={e => HouseManualAction.onEdit(e)} />
            </div>
            <div className="col-6">
              <LabeledInputField label="Korean" name="title_ko" value={record.title_ko} onChange={e => HouseManualAction.onEdit(e)} />
            </div>
          </div>
        </div>
        <div className="ManualDialog__keywords">
          <p>
            検索キーワード
            <span className="required">*</span>
            <span className="help">カンマで「,」区切って複数個指定できます</span>
          </p>
          <div className="row">
            <div className="col">
              <LabeledInputField label="Japanese" name="keywords_ja" value={record.keywords_ja} onChange={e => HouseManualAction.onEdit(e)} />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <LabeledInputField label="English" name="keywords_en" value={record.keywords_en} onChange={e => HouseManualAction.onEdit(e)} />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <LabeledInputField label="Chinese" name="keywords_zh" value={record.keywords_zh} onChange={e => HouseManualAction.onEdit(e)} />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <LabeledInputField label="Korean" name="keywords_ko" value={record.keywords_ko} onChange={e => HouseManualAction.onEdit(e)} />
            </div>
          </div>
        </div>
        <div className="ManualDialog__action">
          <div className="buttons">
            <NormalButton onClick={e => HouseManualAction.onCancel()}>キャンセル</NormalButton>
            <OutlinedButton onClick={saveAction}>保存する</OutlinedButton>
          </div>
        </div>
      </div>
    </div>
  )
}

function LabeledInputField(props) {
  return (
    <div className={`LabeledInputField ${props.className || ''}`}>
      <span>{props.label}</span>
      <input type="text" name={props.name} value={props.value} onChange={props.onChange} />
    </div>
  )
}

export default SettingTabletView
